import { ChatMessageResponse } from 'src/app/models/chat.model';
import { ChatMessageRole } from 'src/app/enums/chatMessageRole.enum';

/**
 * Renders the visible thread to Markdown: a heading with the chat title, then each user/assistant turn
 * labelled by author, in order. Tool messages are skipped since they are not part of the visible thread.
 */
export function buildChatMarkdown(chatTitle: string, messages: ChatMessageResponse[]): string {
  const lines: string[] = [`# ${chatTitle}`];

  for (const message of messages) {
    const label = authorLabel(message.role);
    if (label === null) {
      continue;
    }
    lines.push('', `## ${label}`, '', message.content);
  }

  return `${lines.join('\n')}\n`;
}

function authorLabel(role: ChatMessageRole): string | null {
  switch (role) {
    case ChatMessageRole.User:
      return 'You';
    case ChatMessageRole.Assistant:
      return 'Assistant';
    default:
      return null;
  }
}
